<template>
    <div class="container-fluid img_backgrond">
        <div class="row">
            <!--<div class="col-lg-4 offset-lg-4 col-sm-6 offset-sm-3 col-xs-10 offset-xs-1 login-content mt-5">-->
            <div class="login-content mt-5">

                <div class="row">
                    <div class="col-sm-12 mt-4">
                        <h2 class="text-center">
                            <router-link :to="{ name: 'login' }"><img src="../../img/id-plein.png" alt="Logo"></router-link>
                        </h2>
                    </div>
                    <div class="col-sm-12 mt-4">
                        <h3 class="page-name text-center">{{ uLang('app.forgot_password') }}</h3>
                    </div>
                </div>
                <form class="form-horizontal" enctype="multipart/form-data" @submit.prevent="send" @keydown="form.errors.clear($event.target.name)">
                    <div class="col-md-12">
                        <p class="user-message">{{ uLang('app.forgot_password_sub_text') }}</p>
                        <div class="form-group" v-bind:class="{ 'has-error' : form.errors.has('email') }">
                           <input type="text" class="form-control" name="email" :placeholder="uLang('app.email_cm')" v-model="form.email" required>
                           <span class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
                       </div>
                    </div>
                    <div class="col-12 mt-4">
                        <div class="form-group">
                            <input type="submit" :disabled="form.busy" :value="uLang('app.send_reset_link')" class="btn btn-brand btn-block" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Form from '~/Form/Form'
import { SuccessAlert } from "~/Swals";

export default {
    name: "forgetpassword",
    data() {
        return {
            form: new Form({
                email: ''
            })
        }
    },
    methods: {
        async send () {
          const response = await this.form.post('/api/password/email')

            this.form.reset()

            new SuccessAlert({ text: response.message }).show()
        }
    },
    mounted: function() {
        this.$on('')
    },
    destroyed: function() {

    }
}
</script>
<style lang="scss" scoped>
.has-error {
    color: red;
    input {
        border-color: red;
    }
}
.login-content {
    margin-top: 7%;
    margin-bottom: 7%;
    padding-bottom: 20px;
    box-shadow: 0 0 20px #ccc;
    /*background-image: url("../assets/img/pages/profile-coverbg.jpeg");*/
    background-size: 100% 100%;
    border-radius: 7px;
    /*position: absolute;*/
    /*top:10%;*/
}

.user-message {
    padding: 15px 0;
    font-size: 14px;
    color: #777;
}
.img_backgrond{
    background-image: url("../../img/pages/Login-03-01.png");
    background-size: cover;
    height: 100vh;
    width:100%;
}
label{
    font-size: 14px !important;
}
::-webkit-input-placeholder {
    font-size:14px;
}

.login-content{
    margin: 0 auto;
    width: 330px;
    max-width: 330px;

    @media screen and (max-width: 360px){
        margin: 0 15px;
    }
}
</style>
